import { moment } from "@msuite/utils/date";
import { motion } from "motion/react";
import { Button } from "../button";
import { Icon } from "../icons";
import { type QueryKey, useIsFetching, useQueryClient } from "../query";
import { WeekPicker } from "../week-picker";
import { useTimelineWeeklyControls } from "./use-timeline-weekly-controls";

/** Props Interface */
interface TimelineWeeklyControlsProps {
	queryKey: QueryKey;
	withRefreshButton?: boolean;
}

export function TimelineWeeklyControls({
	queryKey,
	withRefreshButton = true,
}: TimelineWeeklyControlsProps) {
	/** Hooks */
	const qc = useQueryClient();
	const isFetching = useIsFetching({ queryKey });
	const { currentWeek, onBack, onForward } = useTimelineWeeklyControls();

	/** Functions */
	async function refetch() {
		await qc.invalidateQueries({ queryKey });
	}

	/** Render */
	return (
		<motion.div
			className="top-0 z-50 sticky md:h-stack v-stack"
			layoutId="timeline-weekly-controls"
			layout="position"
		>
			<div className="flex-1" />
			<WeekPicker
				currentWeek={moment().getMomentByDbWeek(currentWeek)}
				onBack={onBack}
				onForward={onForward}
			/>
			{withRefreshButton && (
				<Button
					icon={<Icon name="RefreshCw" />}
					onClick={refetch}
					isLoading={!!isFetching}
				/>
			)}
		</motion.div>
	);
}
